<template>
    <div :class="{'ck-new-contact' : formShown, 'section': !setright}">
        <div class="columns">
            <div class="column is-6" :class="(setright) ? 'is-offset-6' : ''">
                <button class="button button-form-hidden is-primary"
                    :class="(button === 'small') ? 'is-small' : ''"
                    @click="toggleClicked"
                    title="Anzeigen/Ausblenden">
                    <span v-if="!formShown">Kontakt hinzufügen</span> <i v-if="!formShown" class="fa fa-plus"></i>
                    <span v-if="formShown">Formular verbergen</span> <i v-if="formShown" class="fa fa-minus"></i>
                </button>
            </div>
        </div>
        <transition name="bounce">
            <ck-flash :message="flash.message"  :type="flash.type" v-if="flash.active"></ck-flash>
        </transition>
        <form class="form" v-if="formShown">
            <div class="field is-horizontal">
                <div class="field-body">
                    <div class="field">
                        <div class="control ck-search-select">
                            <label for="description" class="label">{{ translatedType }}</label>
                            <model-select v-if="!modelId" :options="options"
                                        v-model="item"
                                        placeholder="Spieler auswählen"
                                        >
                            </model-select>
                            <input v-if="modelId" type="text" disabled class="input" :value="item.text" />
                        </div>
                    </div>
                    <div class="field">
                        <div class="control ck-search-select">
                            <label for="type" class="label">Typ</label>
                            <model-select :options="types"
                                        v-model="selectedType"
                                        placeholder="Typ auswählen"
                                        >
                            </model-select>
                        </div>
                    </div>
                    <div class="field">
                        <div class="control ck-search-select">
                            <label for="type" class="label">Datum</label>
                            <input class="input input-date" id="date"
                                        v-model="selectedDate"
                                        v-pikaday
                                        >
                        </div>
                    </div>
                </div>
            </div>
            <div class="field">
                    <div class="control">
                        <label for="description" class="label">Beschreibung</label>
                        <textarea v-model="description" @keyup="resetFlash" class="textarea" name="description" id="description" cols="30" rows="4"></textarea>
                    </div>
                </div>
            <div class="field is-grouped">
                <div class="control">
                    <button @click.prevent="sendContactToApi" class="button is-primary" :class="(loading) ? 'is-loading' : ''">Erstellen</button>
                </div>
                <div class="control">
                    <button @click.prevent="resetForm" type="reset" class="button is-outlined">Zurücksetzen</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import Moment from 'moment'
import V_Pikaday from '../directives/pikaday';

export default {
    props: ['type', 'modelId', 'button', 'setright'],
    directives: {
         'pikaday': V_Pikaday
    },
    data () {
      return {
        userFromId: '',
        formShown: false,
        options: [],
        item: {
          value: '',
          text: ''
        },
        selectedType: {
            value: '',
            text: ''
        },
        selectedDate: '',
        modeltype: null,
        flash: {
            active: false,
            message: ''
        },
        description: '',
        loading: false
      }
    },
    components: {
      ModelSelect
    },
    beforeCreate: function() {
        let _url, _modeltype;

        if (this.$options.propsData.type === 'player') {
            _url = `/playerlist?noPaginate=1`
            _modeltype = 'player'
        }
        if (this.$options.propsData.type === 'person') {
            _url = `/peoplelist?noPaginate=1`
            _modeltype = 'person'
        }
            axios.get(_url).then(res => {
              this.modeltype = _modeltype
                console.log(res)

              res.data.map(player => {
                  this.options.push({ text: `${player.firstname} ${player.lastname}`, value: player.id })
              })

              return;
          })
          .then(_ => {
                // we want to lock down the modelid if there is a modelid prop
                if (this.$props.modelId) {
                    var _user;

                    this.$data.options.forEach(option => {
                        if( parseInt(this.$props.modelId) === option.value ) {
                            _user = { value: option.value, text: option.text}
                        }
                    })

                    this.$data.item.value = _user.value
                    this.$data.item.text = _user.text
                }
          })
          .catch(e => {
          });
    },
    mounted: function() {
        //this.selectedDate = new Date().toISOString().slice(0,10);
    },
    computed: {
        translatedType: function() {
            if (this.type === 'player') return 'Spieler';
            if (this.type === 'person') return 'Person';

            return 'Kontaktierter';
        },
        types: function() {
            if (this.type === 'player') {
                return [
                    { text: 'telefonisch', value: 'telefonisch' },
                    { text: 'persönlich', value: 'persönlich' },
                    { text: 'Spiel beobachtet', value: 'Spiel beobachtet' },
                    { text: 'Training beobachtet', value: 'Training beobachtet' },
                ];
            }

            return [
                {text: 'telefonisch', value: 'telefonisch'},
                {text: 'persönlich', value: 'persönlich'},
            ]
        }
    },
    methods: {
        toggleClicked() {
            if (this.flash.active) {
                this.flash.active = !this.flash.active
            }
            if (!this.flash.active && this.flash.message !== '' && !this.formShown) {
                this.flash.active = !this.flash.active
            }

            return this.formShown = !this.formShown

        },
        resetFlash() {
            this.flash = {
                active: false,
                type: '',
                message: ''
            }
        },
        sendContactToApi () {
            if (!this.description || this.item.value === '') {
                this.flash = {
                    active: true,
                    type: 'is-warning',
                    message: 'Um einen neuen Kontakt zu erstellen muss sowohl der Spieler als auch der Inhalt angegeben werden!'
                }

                return;
            }

            this.loading = true;

            let data = new FormData();
            data.append('description', this.description);
            data.append('id', this.item.value);
            data.append('contact_type', this.selectedType.value);
            data.append('modeltype', this.modeltype);
            data.append('date', this.selectedDate);

            axios.post(`/contacts`, data).then(res => {
                this.loading = false;
                this.flash = {
                    active: true,
                    type: 'is-success',
                    message: 'Kontakt erstellt.'
                };

                this.description = '';
                this.selectedType.value = '';
                this.date = '';
            }).catch(e => {
                this.flash = {type: 'is-danger', message: 'Es ist ein Fehler aufgetreten. Nachricht: ' + e, active: true};
                this.loading = false;
            });
        },
        reset () {
            this.item = {}
        },
        resetForm () {
            this.item.value = ''
            this.description = ''
            this.selectedType.value = ''
            this.selectedType.text = ''
            this.modeltype = null
        },
        selectOption () {
            // select option from parent component
            this.item = this.options[0]
        }
    }
}
</script>

<style scoped>
    .input-date {
        padding: 0.67861429em 1em 0.67861429em 1em;
        height: 43px;
    }

    .button {
        width: 100%;
    }

    .button i {
        margin-left: 1rem;
    }

    .ck-new-contact {
        outline: 1px solid #ddd;
        padding: 0.2;
        margin-bottom: 2rem;
    }

    .bounce-enter-active {
        animation: bounce-in .2s;
    }
    .bounce-leave-active {
        animation: bounce-in .2s reverse;
    }

    @keyframes bounce-in {
    0% {
        transform: scale(0);
    }
    100% {
        transform: scale(1);
    }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ckAddContact.vue